import * as actions from '../utils/Constants';
import { apiGet, apiDeleteWithBodyAndThen, apiPost, apiPostAndThen, apiRequest, Methods } from '../utils/Api';
const api = `${process.env.REACT_APP_API_HOST}api/program/`;


export const getProgramGrants = (id) => dispatch =>
    dispatch({
        type: actions.GET_PROGRAM_GRANTS,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/program/${id}/grants`)
    })

export const getAvailableProgramsList = (trainingId) => dispatch =>
    dispatch({
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/programSearch`)
});

export const clearProgramState = () => {
    return { type: actions.CLEAR_PROGRAM_DATA };
};

export const updateProgram = (program) => {
    return {
        type: actions.UPDATE_PROGRAM,
        payload: apiPost(api, program)
    }
}

export const updateProgramAndSaveToTraining = (program, trainingId) => {
    return dispatch => dispatch({
        type: actions.ADD_PROGRAM_FROM_TRAINING,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/program/training/${trainingId}`, Methods.post, program, dispatch)
    });
};

export const addProgramGrants = (programId, grantIds) => {
    return dispatch => {
        apiRequest(`${process.env.REACT_APP_API_HOST}api/program/${programId}/programs`, Methods.post, grantIds, dispatch).then(() => {
            dispatch(getProgramGrants(programId));
        })
    };
}

export const clearSearchedGrants = () => {
    return {
        type: actions.ADD_PROGRAM_GRANTS
    }
};

export const deleteProgramGrants = (programId, grantIds) => {
    return dispatch => {
        apiRequest(`${process.env.REACT_APP_API_HOST}api/program/${programId}/grants`, Methods.delete, grantIds, dispatch).then(() => {
            dispatch(getProgramGrants(programId));
        })
    };
}

export const setField = (field, value) => ({
    type: actions.SET_PROGRAM_FIELD,
    field,
    payload: value
});

export const setAddressField = (field, value) => ({
    type: actions.SET_PROGRAM_ADDRESS_FIELD,
    field,
    payload: value
});


export const setPhoneField = (value) => ({
    type: actions.SET_PROGRAM_PHONE_FIELD,
    payload: value
});


export const addPointOfContact = (contact) => ({
    type: actions.ADD_PROGRAM_POINTOFCONTACT,
    payload: contact
});

export const toggleValidState = (value) => ({
    type: actions.TOGGLE_CONTACT_NAME_IS_VALID,
    payload: value
})

export const toggleContactPhoneIsValid = (value) => ({
    type: actions.TOGGLE_CONTACT_PHONE_IS_VALID,
    payload: value
})

const getContactsApi = (id) => apiGet(`${process.env.REACT_APP_API_HOST}api/program/${id}/contacts`)

export const addProgramContact = (id, contact) => ({
    type: actions.ADD_PROGRAM_CONTACT,
    payload: apiPostAndThen(`${process.env.REACT_APP_API_HOST}api/program/contact`, contact, () => getContactsApi(id))
});

export const addProgramContacts = (id, contacts) => ({
    type: actions.ADD_PROGRAM_CONTACT,
    payload: apiPostAndThen(`${process.env.REACT_APP_API_HOST}api/program/contacts`, contacts, () => getContactsApi(id))
});

export const addPrimaryContact = (contactId, programId) => ({
    type: actions.MAKE_PRIMARY_CONTACT,
    payload: apiPostAndThen(`${process.env.REACT_APP_API_HOST}api/program/contact/${contactId}/makePrimary`, () => getContactsApi(programId))
});

export const getProgramContacts = (id) => ({
    type: actions.GET_PROGRAM_CONTACTS,
    payload: getContactsApi(id)
});

export const deleteProgramContacts = (id, ids) => ({
    type: actions.REMOVE_PROGRAM_CONTACTS,
    payload: apiDeleteWithBodyAndThen(`${process.env.REACT_APP_API_HOST}api/program/contacts`, ids, () => getContactsApi(id))
});

const getProgramJournalApi = (programId) => apiGet(`${process.env.REACT_APP_API_HOST}api/program/${programId}/journal`)

export const saveProgramJournalEntry = (programId, journalEntry) => ({
    type: actions.ADD_UPDATE_PROGRAM_JOUNALENTRY,
    payload: apiPostAndThen(`${process.env.REACT_APP_API_HOST}api/program/journal`, journalEntry, () => getProgramJournalApi(programId))
});

export const getProgramJournal = (programId) => ({
    type: actions.GET_PROGRAM_JOURNAL,
    payload: getProgramJournalApi(programId)
});

export const deleteProgramJournalEntries = (programId, ids) => ({
    type: actions.DELETE_PROGRAM_JOUNALENTRIES,
    payload: apiDeleteWithBodyAndThen(`${process.env.REACT_APP_API_HOST}api/program/journal`, ids, () => getProgramJournalApi(programId))
});

export const getProgramDocuments = (programId) => {
    return dispatch => dispatch({
        type: actions.GET_PROGRAM_DOCUMENTS,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/program/${programId}/documents`, Methods.get, null, dispatch)
    });
};

export const addProgramDocument = (programId, type, files) => {
    const data = new FormData();
    files.forEach(file => data.append('files', file, file.fileName));

    return {
        type: actions.ADD_PROGRAM_DOCUMENT,
        payload: fetch(`${process.env.REACT_APP_API_HOST}api/program/${programId}/document/${type}`, {
            method: 'POST',
            credentials: 'include',
            body: data
        }).then(res => {
            return res.json();
        })
    }
}

export const deleteProgramDocuments = (programId, ids) => ({
    type: actions.DELETE_PROGRAM_DOCUMENTS,
    payload: apiDeleteWithBodyAndThen(`${process.env.REACT_APP_API_HOST}api/program/documents`, ids, () =>
        apiGet(`${process.env.REACT_APP_API_HOST}api/program/${programId}/documents`))
});

export const updateProgramDocument = (programId, programDocumentId, documentTypeId) => {
    return dispatch => {
        apiRequest(`${process.env.REACT_APP_API_HOST}api/program/document/${programDocumentId}`, Methods.put, documentTypeId, dispatch).then(() => {
            dispatch(getProgramDocuments(programId));
        })
    }
};

export const getProgramTrainings = (sessionId, programId) => dispatch =>
    dispatch({
        type: actions.GET_PROGRAM_TRAININGS,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/session/${sessionId}/program/${programId}/trainings`, Methods.get, null, dispatch)
    });